import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router } from '@angular/router';
import { Observable } from 'rxjs-compat/Observable'
import { LabApiConfiguration } from '../apiConfiguration';
import { SpecimenTransactionChangeStatusViewModel } from '../../../models/lab/specimenTransactionChangeStatusViewModel';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)

@Injectable()
export class SpecimenTransactionStatusService extends ServiceBase {

    private actionUrl: string;
    private _changeToCollected: string;
    private _changeSpecimenTransactionStatus: string;
    private _patientReleaseUrl: string;
    // private _specimenBarCodeReportURL;

    constructor(private _http: HttpClient, private _configuration: LabApiConfiguration, private _router: Router) {
        super();
        this.actionUrl = _configuration.server;
        this._changeToCollected = this.actionUrl + _configuration.specimenTransactionStatus.changeToCollected;
        this._changeSpecimenTransactionStatus = this.actionUrl + _configuration.specimenTransactionStatus.changeSpecimenTransactionStatus;
        this._patientReleaseUrl = this.actionUrl + _configuration.specimenTransactionStatus.patientRelease;
        // this._specimenBarCodeReportURL = _configuration.getSpecimenBarCodeReportURL();
    }
    changeToCollected = (viewModel): Observable<any> => {
        return this._http.post<any>(this._changeToCollected, viewModel);
    }

    changeSpecimenTransactionStatus = (specimenTransactionChangeStatusViewModel: SpecimenTransactionChangeStatusViewModel): Observable<any> => {
        return this._http.post<any>(this._changeSpecimenTransactionStatus, specimenTransactionChangeStatusViewModel);
    }

    acceptSpecimen = (specimenTransactionChangeStatusViewModel: SpecimenTransactionChangeStatusViewModel): Observable<any> => {
        return this._http.patch(`${this.actionUrl}SpecimenTransactionStatus/Acceptance`, specimenTransactionChangeStatusViewModel);
    }

    patientRelease = (): Observable<any> => {
        return this._http.get<any>(`${this._patientReleaseUrl}`);
    }

    // getSpecimenBarCodeReportURL = (): Observable<string> => {
    //     return this._specimenBarCodeReportURL;
    // }
}
